// tslint:disable: completed-docs
/**
 * Own area for container
 */
import {SAILS_APP_NAME} from 'Constant';
import { IErrorHandling } from 'Container/OfferDisplay/types';
// Store for the Container
export const LANDINGPAGE_STORE = 'LANDINGPAGE';

export const SET_DEFAULT_STATE = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/SET_DEFAULT_STATE`;

// For offer data loading
export const GET_OFFERS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/GET_OFFERS`;
export const GET_OFFERS_SUCCESS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/GET_OFFERS_SUCCESS`;
export const GET_OFFERS_FAILED = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/GET_OFFERS_FAILED`;

export const PRESELECT_OFFERS_SUCCESS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/PRESELECT_OFFERS_SUCCESS`;

// For additional content loading
export const GET_ADDITIONAL_CONTENTS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/GET_ADDITIONAL_CONTENTS`;
export const GET_ADDITIONAL_CONTENTS_SUCCESS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/GET_ADDITIONAL_CONTENTS_SUCCESS`;
export const GET_ADDITIONAL_CONTENTS_FAILED = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/GET_ADDITIONAL_CONTENTS_FAILED`;

export const ADDITIONAL_CONTENT_USEMOCK_URL_PARAM = 'useMock';

export const SELECT_MULTIPICKER = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/SELECT_MULTIPICKER`;
export const SELECT_MULTIPICKER_SUCCESS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/SELECT_MULTIPICKER_SUCCESS`;
export const PRE_SELECT_MULTIPICKER_SUCCESS = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/PRE_SELECT_MULTIPICKER_SUCCESS`;

export const TOGGLE_DEFAULT_NOTIFICATION = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/DISPLAY_DEFAULT_NOTIFICATION`;

// jsonOfferDataValidator
export const JSON_DOES_NOT_MATCH_STRUCTURE = 'JSON_Element does not match given structure.';
export const JSON_LENGTH_IS_ZERO = 'JSON length is zero.';

export const JSON_IS_NOT_VALID = 'JSON is not valid.';
export const JSON_VALIDATION_PROPERTY_ARRAY_ERROR = 'The given property array is not valid!';
export const JSON_VALIDATION_PROPERTY_NOT_FOUND = (propertyName: string) => {
    return `Attribute '${propertyName}' is missing from JSON!`;
};
export const JSON_AND_ARRAY_LENGTH_NOT_EQUAL = (jsonLength: number, arrayLength: number) => {
    return `JSON (l:${jsonLength}) and validator array (l:${arrayLength}) length must be equal!`;
};
export const ERROR_HANDLING_SUCCESS_RESULT: IErrorHandling = { error: false };

// Track Events
export const ACCORDION_OPENED = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/ACCORDION_OPENED`;
export const FAQ_ACCORDION_TOGGLE = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/FAQ_ACCORDION_TOGGLE`;
export const HOTLINE_BUTTON_CLICK = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/HOTLINE_BUTTON_CLICK`;
export const NOTIFICATION_HOTLINE_LINK_CLICK = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/NOTIFICATION_HOTLINE_LINK_CLICK`;
export const OFFER_GETS_VISIBLE = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/OFFER_GETS_VISIBLE`;
export const OFFER_ALREADY_VISIBLE_ON_PAGELOAD = `${SAILS_APP_NAME}/${LANDINGPAGE_STORE}/OFFER_ALREADY_VISIBLE_ON_PAGELOAD`;
